import {useTypedSelector} from "../../../hooks/useTypedSelector";
import {MusicService} from "../../../services/MusicService";
import {useActions} from "../../../hooks/useActions";
import StorageHelper from "../../../services/StorageHelper";

function MusicButton() {
    const {music} = useTypedSelector(state => state.auth);
    const {setMusic} = useActions();

    let musicImageClass = ' menuMusicImageON';

    if(music.playMenu === false){
        musicImageClass = ' menuMusicImageOFF';
    }

    const OnOfMusic = function () {

        if (music.playMenu === true) {
            music.playMenu = false;
            MusicService.stopMenu();
        } else {
            music.playMenu = true;
            MusicService.playMenuMusic();
        }

        StorageHelper.set('playMenu', music.playMenu);

        setMusic(music);
    };

    return (
        <div className={"main_menu_music_button" + musicImageClass} title="On\Off Music" onClick={() => {
            OnOfMusic();
        }}>

        </div>
    );
}

export default MusicButton;